import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function clearCacheSetup(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('clearCache')) {
        return;
    }

    return function clearCache(...routePrefixes: string[]): Promise<void> {
        return messageBus
            .sendRequest('clearCache', Maybe.just<string>(JSON.stringify({ routePrefixes })))
            .then(function() {
                // return void alerting the cache has been cleared
                return;
            });
    };
}
